import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { opt } from 'store/opt'
import { formatPrice, Item } from 'type/Item'
import { getTranslation } from 'util/translations'
import css from './ItemCard.module.scss'

type Props = {
  item: Item
}

export const ItemCard = observer(({ item }: Props) => {
  const demo = useDemo()
  const { show_name, stand, tsum } = demo
  const { articles, brands, colors, prices } = demo.product.items ?? {}
  const { product_name, article, brand_name, dress_colors, images } = item
  const f1 = stand ? 11 : 9
  const f2 = stand ? 13 : 11
  const src = images[1] || images[0]
  const selected = itemPreview.it.combo === item
  const className = clsx(css.item, selected && css.selected, opt.square && css.square)

  const price = formatPrice(item.prices)
  const weight = tsum ? 500 : 600

  const onClick = useLatestCallback(() => {
    itemPreview.it.toggleCombo(item)
  })

  return <Vertical className={className} onClick={onClick}>
    <Space className={css.image} ratio={demo.product.ratio || '3 / 4'}>
      <Image src={src} />
    </Space>
    <Space className={css.circle} center>
      <Icon size={28} name="check_circle" />
    </Space>
    <Gap height={12} />
    <Vertical gap={8} oh>
      {articles && article && (<Space gap={4} center height={16}>
        <Space>
          <Icon size={16} name="barcode" secondary tertiary={stand} />
        </Space>
        <Typo size={f1} line={16} upper secondary tertiary={stand} wrap>
          {article}
        </Typo>
      </Space>)}
      {((brands && brand_name) || show_name) && <Vertical>
        {brands && brand_name && <Typo size={f1} upper secondary tertiary={stand} center wrap>
          {brand_name}
        </Typo>}
        {show_name && <Typo size={f2} weight={weight} first upper center wrap>
          {product_name}
        </Typo>}
      </Vertical>}
      {colors && dress_colors && (
        <Typo size={f1} upper center wrap>
          {getTranslation('colors', dress_colors)}
        </Typo>
      )}
      {prices && price && (
        <Typo size={f2} weight={weight} first primary={tsum} center>
          {price}
        </Typo>
      )}
    </Vertical>
  </Vertical>
})
